import { ReactNode } from "react";

export function SplitScreen({ firstComponent, secondComponent }: { firstComponent: ReactNode, secondComponent: ReactNode }) {
  return (
    <div className="h-screen lg:max-w-screen-2xl mx-auto grid grid-cols-1 md:grid-cols-2">
      <div className="md:flex flex-col items-center justify-center hidden">
        <div className="min-h-[calc(100vh-16vh)] grow w-full p-6">
          {firstComponent}
        </div>
      </div>

      <div className="flex flex-col items-center justify-center">
        <div className="min-h-[calc(100vh-16vh)] w-full p-6">
          {secondComponent}
        </div>
      </div>
    </div>
  );
}